export default __webpack_public_path__ + "static/media/fontainebleau.2c75209e.jpg";